import React from 'react';
import TimeDisplay from './timeDisplay';
import { View } from 'react-native';
import { isWeb } from '@helpers';

const TimelineWithTimeLabels = ({ values = [], C, font, scale, convertTime, convertTimeLetter, formatTimeEvent, children, tourId }) => {
  const validItems = values.reduce((acc, item, index) => {
    if (item?.value != null) {
      acc.push({ ...item, originalIndex: index });
    }
    return acc;
  }, []);

  const singleItem = validItems.length === 1;

  const webProps = isWeb && tourId ? { dataSet: { tourId } } : {};

  return (
    <View style={{ width: '100%' }} {...webProps}>
      <View
        style={{
          height: scale(16),
          flexDirection: 'row',
          justifyContent: singleItem ? 'flex-start' : 'space-between',
          alignItems: 'center',
        }}
      >
        {validItems.map((item) => (
          <View key={item.originalIndex} style={{ flexDirection: 'row', alignItems: 'center', gap: scale(2) }}>
            {item.Indicator ?? null}
            <TimeDisplay
              showPlus={item.showPlus}
              value={item.value}
              color={item.color}
              C={C}
              font={font}
              scale={scale}
              convertTime={convertTime}
              convertTimeLetter={convertTimeLetter}
              formatTimeEvent={formatTimeEvent}
            />
          </View>
        ))}
      </View>
      {children}
    </View>
  );
};

export default TimelineWithTimeLabels;
